
import ReactDOM from 'react-dom'; 
import React, { useState } from 'react';
import {GridWrap, ListWrap, Elements} from "./helpers" 
import app from "./app" 

export const ContactProfile = function({data, index, widgetType, mode, device}) { 
    // console.log("ContactOne", data)    
 return  <div className={`d-flex justify-content-${data.properties.itemAlignment}`}> 
                 <Elements row={data.elements.banner} id={"banner"} device={device} mode={mode} classType="w-auto"/>
                 <div className="overflow-hidden">
                    <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode} />
                    <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode} /> 
                 </div> 
         </div>  
 }
 
export const ContactTwo = function({data, index, widgetType, mode, device}) { 
//    console.log("ContactOne", data)   
    const openPopup = function(data, callback){
        const div = document.createElement("div");
        document.body.appendChild(div);
        ReactDOM.render(<ContactModel data={data}/>, div);
    }

    let listitem = "" 
    if(data.elements.contacts){ 
         if(data.elements.contacts.items){   
            listitem = data.elements.contacts.items.map(function(v, i){ 

                let isShow =  v.heading.properties.show || v.contactLinks.properties.show;
                if(device === "desktop"){
                    isShow =  v.heading.properties.showWeb || v.contactLinks.properties.showWeb;
                }
               // console.log(v)    
                return <GridWrap className="h-100" data={v} key={'key-' + v.viewId + i} id="contacts" mode={mode} device={device}>
                    <Elements row={v.icon} id={"icon"} device={device}/>
                    {/* <div className="overflow-hidden"> */}
                            <Elements row={v.heading} id={"heading"} device={device} mode={mode} /> 
                            <Elements row={v.contactLinks} id={"contactLinks"} device={device} mode={mode} />
                    {/* </div>  */}
                   
                    {app.getMode(mode) && isShow?<a className='link-overlay' onClick={() => openPopup(v)}></a>:""}
                </GridWrap> 
            }) 
        } 
        listitem = <ListWrap data={data.elements.contacts} className="g-2 g-md-4 g-lg-4 align-items-start justify-content-start justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-center" mode={mode} device={device} index={index}>
            {listitem}
        </ListWrap>
    }

return  <div className="container-fluid p-0 position-relative"> 
        <div className="row">
            <div className="col-12">
                <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode} />
                <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode} />  
            </div>
        </div>
        {listitem} 
    </div>
}

export const ContactOne = function({data, index, widgetType, mode, device}) { 
    // console.log("ContactOne", data)    
        const openPopup = function(data, callback){
            const div = document.createElement("div");
            document.body.appendChild(div);
            ReactDOM.render(<ContactModel data={data}/>, div);
        }
 
        let listitem = "" 
        if(data.elements.contacts){ 
             if(data.elements.contacts.items){   
                listitem = data.elements.contacts.items.map(function(v, i){ 
                   // console.log(v)    
                    let isShow =  v.heading.properties.show || v.contactLinks.properties.show;
                    if(device === "desktop"){
                        isShow =  v.heading.properties.showWeb || v.contactLinks.properties.showWeb;
                    }
                    return <GridWrap className="h-100 position-relative" data={v} key={'key-' + v.viewId + i} id="contacts" mode={mode} device={device}>
                        <div className={`d-flex justify-content-${data.properties.itemAlignment}`}> 
                            <Elements row={v.icon} id={"icon"} device={device} classType="float-start"/>
                            <div className="overflow-hidden w-100">
                                <Elements row={v.heading} id={"heading"} device={device} mode={mode} /> 
                                <Elements row={v.contactLinks} id={"contactLinks"} device={device} mode={mode} />
                            </div>
                        </div>  
                        {app.getMode(mode) && isShow?<a className='link-overlay' onClick={() => openPopup(v)}></a>:""}
                    </GridWrap> 
                }) 
            } 
             listitem = <ListWrap data={data.elements.contacts} className="g-3 align-items-start justify-content-start" index={index}>
                {listitem}
            </ListWrap>
        }
    
    return  <div className="container-fluid p-0 position-relative"> 
            <div className="row">
                <div className="col-12">
                    <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode} />
                    <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode} />  
                </div>
            </div>
            {listitem} 
        </div>
    }

 
const ContactModel = ({ data }) => {
    // console.log("data----", data)
    const [isVisible, setIsVisible] = useState(true); 
    const remove = () => {
        setIsVisible(false);
    };
    
    const generateItemData = () => {
        if (data.contactLinks) {
        return data.contactLinks.contactItems.map((v, i) => {
             let show = "";
            let showWeb = ""
            if(data.heading.properties.show === false){
                show = "mobile-d-none"
            }
            if(data.heading.properties.showWeb === false){
                showWeb = "desktop-d-none"
            }

            let showVal = "";
            let showWebVal = ""
            if(data.contactLinks.properties.show === false){
                showVal = "mobile-d-none"
            }
            if(data.contactLinks.properties.showWeb === false){
                showWebVal = "desktop-d-none"
            }
            

            switch (v.type) {
            case "textHtml":
                return (
                    <div key={`key-${i}`} className="list-group-item px-0 py-3 d-flex">
                        {/* <i className="icons iconz-global"></i> */}
                        <span>
                        <small className={`fw-bold d-block text-capitalize pb-1 text-muted ${show} ${showWeb}`} dangerouslySetInnerHTML={{__html:data.heading.text}}/>
                        <div className={`${showVal} ${showWebVal}`}>{v.value}</div>
                        </span>
                    </div>
                    );
            case "url":
                return (
                <a key={`key-${i}`} className="list-group-item px-0 py-3 d-flex" target='_blank' href={v.value}>
                    {/* <i className="icons iconz-global"></i> */}
                    <span>
                    <small className={`fw-bold d-block text-capitalize pb-1 text-muted ${show} ${showWeb}`} dangerouslySetInnerHTML={{__html:data.heading.text}}/>
                    <div className={`${showVal} ${showWebVal}`}>{v.value}</div>
                    </span>
                </a>
                );
            case "email":
                return (
                <a key={`key-${i}`} className="list-group-item px-0 py-3 d-flex" target='_blank' href={`mailto:${v.value}`}>
                    {/* <i className="icons icon-email"></i> */}
                    <span>
                    <small className={`fw-bold d-block text-capitalize pb-1 text-muted ${show} ${showWeb}`} dangerouslySetInnerHTML={{__html:data.heading.text}}/>
                    <div className={`${showVal} ${showWebVal}`}>{v.value}</div>
                    </span>
                </a>
                );
            case "phone":
                return (
                <a key={`key-${i}`} className="list-group-item px-0 py-3 d-flex" target='_blank' href={`tel:${v.value}`}>
                    {/* <i className="icons iconz-phone1"></i> */}
                    <span>
                    <small className={`fw-bold d-block text-capitalize pb-1 text-muted ${show} ${showWeb}`} dangerouslySetInnerHTML={{__html:data.heading.text}}/>
                    <div className={`${showVal} ${showWebVal}`}>{v.value}</div>
                    </span>
                </a>
                );
            case "skype":
                return (
                <a key={`key-${i}`} className="list-group-item px-0 py-3 d-flex" target='_blank' href={`https://skype.com/${v.value}`}>
                    {/* <i className="icons icon-skype-1"></i> */}
                    <span>
                    <small className={`fw-bold d-block text-capitalize pb-1 text-muted ${show} ${showWeb}`} dangerouslySetInnerHTML={{__html:data.heading.text}}/>
                    <div className={`${showVal} ${showWebVal}`}>{v.value}</div>
                    </span>
                </a>
                );
            case "whatsapp":
                return (
                <a key={`key-${i}`} className="list-group-item px-0 py-3 d-flex" target='_blank' href={`https://wa.me/${v.value.split('-').join('')}`}>
                    {/* <i className="icons appyicon-whatsapp"></i> */}
                    <span>
                    <small className={`fw-bold d-block text-capitalize pb-1 text-muted ${show} ${showWeb}`} dangerouslySetInnerHTML={{__html:data.heading.text}}/>
                    <div className={`${showVal} ${showWebVal}`}>{v.value}</div>
                    </span>
                </a>
                );
            case "location":
                return (
                <a key={`key-${i}`} className="list-group-item px-0 py-3 d-flex cursor-pointer" target='_blank' href={`https://maps.google.com/maps?q=${encodeURIComponent(v.value)}`}>
                    {/* <i className="icons icon-location"></i> */}
                    <span>
                    <small className={`fw-bold d-block text-capitalize pb-1 text-muted ${show} ${showWeb}`} dangerouslySetInnerHTML={{__html:data.heading.text}}/>
                    <div className={`${showVal} ${showWebVal}`}>{v.value}</div>
                    </span>
                </a>
                );
            default:
                return null;
            }
        });
        }
        return null;
    };

    let itemLength = ""
    if(data.contactLinks){
        if(data.contactLinks.contactItems.length > 1){
            itemLength = "contact-hide-title";
        }
    }
    return isVisible ? ( 
        <div className="modal" style={{ display: "block" }}>
        <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered">
            <div className="modal-content rounded-3">
            <div className="modal-header border-0 p-0">
                <button type="button" className="close-popup modal-close position-relative fa-sharp icon-cancel icon-cancel" onClick={remove} style={{ zIndex: "1" }}></button>
            </div>
    
            <div className="modal-body py-0">
                <div className={`list-group list-group-flush contact-list ${itemLength}`}>
                    {generateItemData()}
                </div>
            </div>
            </div>
        </div>
        </div>
    ):''
    };